module.exports = __webpack_public_path__ + "assets/img/Telegram.71286e0f.png";